import React from 'react';
import { NavLink as RouterLink, NavLinkProps } from 'react-router-dom';
import { useCurrentLang } from 'services/configuration/i18n/utils';

export const NavLink = ({ children, to, ...props }: NavLinkProps) => {
  const lang = useCurrentLang();
  const modifiedTo = lang === 'en' ? `/en${to}` : lang === 'id' ? `/id${to}` : to;

  return (
    <RouterLink to={modifiedTo} {...props}>
      {children}
    </RouterLink>
  );
};
